import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Grid, useMediaQuery, makeStyles, Snackbar, InputLabel, FormControlLabel, Checkbox, Select, MenuItem, FormControl, Button, TextField, Typography,
} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { useHistory } from 'react-router-dom';
import { empty, api_call, console_log, isEmptyObject } from './helpers/untils';
import { useLocation } from "react-router-dom"
import { sessionActions } from './store';
import { getSettingPersist } from './helpers/misc';
import SmartcarDeviceNoAuthPage from './SmartcarDeviceNoAuthPage';
import { MACHINE_ENVIRONMENT } from './config/constant';
import SmartcarPaymentRequireBlock from './SmartcarPaymentRequireBlock';
import SmartcarV3DeviceNoAuthPage from './SmartcarV3DeviceNoAuthPage';

const SmartCarV3CallbackPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation()

  useEffect(() => {
    processCallbackCode();
  }, []);

  const processCallbackCode = async () => {
    const params = new URLSearchParams(location.search)
    //console_log("params::::", params.get("code"))
    const smartcar_user_id = params.get("user_id")
    if (smartcar_user_id) {
      window.localStorage.setItem("sc-user-id", smartcar_user_id);

      const smartcar_auth_source = getSettingPersist('smartcar_auth_source')
      if (smartcar_auth_source === 'signup') {
        smartCarAuthCallback(smartcar_user_id, smartcar_auth_source)
      } else {
        smartCarDeviceCallback(smartcar_user_id, smartcar_auth_source)
      }
    }
  }

  const smartCarDeviceCallback = async (smartcar_user_id, smartcar_auth_source) => {
    if (smartcar_user_id) {
      const response = await api_call(`/api/smartcar-v3/login-callback?smartcar_user_id=${smartcar_user_id}&smartcar_auth_source=${smartcar_auth_source}`);
      if (response.ok) {
        const res = await response.json()
        console_log("smartcar login callback:::", res)
        history.push(`/smartcar-v3-device?user_id=${smartcar_user_id}`)
        return true
      }
    }
    showToast("Smartcar authentication error")
    setTimeout(() => {
      history.push('/device')
    }, 2000)
  }

  const smartCarAuthCallback = async (smartcar_user_id, smartcar_auth_source) => {
    if (smartcar_user_id) {
      const form_data = {
        ...formData,
        smartcar_user_id: smartcar_user_id
      }
      setFormData(form_data)
      return true
    }

    showToast("Smartcar authentication error!")
    // setTimeout(() => {
    //   history.push('/login')
    // }, 2000)
  }

  const defaultFormData = {
    email: ""
  }
  const [formData, setFormData] = useState(defaultFormData);
  const [item, setItem] = useState({
    version: "v3"
  });
  const [vehicleInfoList, setVehicleInfoList] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const showToast = (msg) => {
    setToastMessage(msg)
    setSnackbarOpen(true)
  }

  const [submitting, setSubmitting] = useState(false)
  const [openConfirmModal, setOpenConfirmModal] = useState(false)

  const onSubmit = async (event) => {
    event.preventDefault();
    setOpenConfirmModal(true)
  }

  const submitApi = async () => {
    const payload = {
      ...formData,
      deviceInfo: item
    }

    console.log(`payload:::`, payload)
    setSubmitting(true)
    showToast("submitting...")
    const response = await api_call('/api/signup-smartcar-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (response.ok) {
      const apiRes = await response.json();
      showToast(apiRes.message)
      redirectToMainPage()
    } else {
      const errorRes = response
      let errorMessage = "Invalid request"
      if (errorRes['error']) {
        errorMessage = errorRes['error']
      }
      setSubmitting(false)
      showToast(errorMessage)
      setOpenConfirmModal(false)
      return false
    }
  }
  const redirectToMainPage = () => {
    setTimeout(() => {
      setSubmitting(false)
      history.push('/login')
    }, 2000)
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '24px', paddingBottom: '48px', paddingLeft: '16px', paddingRight: '16px' }}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        onClose={() => { setSnackbarOpen(false) }}
        autoHideDuration={3000}
        message={toastMessage}
      />

      {
        (!openConfirmModal) ? (
          <>
            <form method="post" onSubmit={onSubmit} style={{ width: '400px', maxWidth: '100%' }}>
              <input type="hidden" name="code" id="smartcar-auth-code" value="" />
              <>
                {
                  (formData['smartcar_user_id']) ? (
                    <Grid container direction="column" spacing={1}>
                      <Grid item xs={12}>
                        <Typography variant='title' component="p" style={{ textAlign: 'center', marginBottom: '20px', fontSize: '24px', fontWeight: 600 }}>OEM Signup</Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          required
                          fullWidth
                          label={`Enter your email`}
                          name="email"
                          type="email"
                          value={formData.email}
                          autoFocus={true}
                          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                          helperText=""
                          variant="filled"
                          disabled={submitting}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <SmartcarV3DeviceNoAuthPage
                          smartcar_user_id={formData['smartcar_user_id']}
                          item={item}
                          setItem={setItem}
                          vehicleInfoList={vehicleInfoList}
                          setVehicleInfoList={setVehicleInfoList}
                          email={formData.email}
                          showToast={showToast}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="secondary"
                          disabled={empty(formData.email) || vehicleInfoList === null || submitting}
                          fullWidth
                        >
                          Submit
                        </Button>
                      </Grid>
                    </Grid>
                  ) : (
                    <></>
                  )
                }
              </>
            </form>
          </>
        ) : (
          <>
            <SmartcarPaymentRequireBlock
              onSubmit={() => submitApi()}
              submitting={submitting}
              setSubmitting={setSubmitting}
            />
          </>
        )
      }
    </div>
  )
}

export default SmartCarV3CallbackPage;
